<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="تخصیص دوره به کارشناس تغذیه"
      :no-close-on-backdrop="true"
      size="sm"
  >
    <b-row>
      <b-col class="col-md-12">
        <b-form-group
            label="کارشناس تغذیه"
            class="d-inline-block full-width"
        >
          <nutritionist-select v-model="UserId" />
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import NutritionistSelect from "@/tools/nutritionistSelect.vue";
export default {
  name: "nutritionistForm",
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  components: { NutritionistSelect },
  data() {
    return {
      loading: false,
      UserId: '',
    }
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        console.log(val)
        if (val && val.UserSpecialDiet) this.UserId = val.UserSpecialDiet.UserNutritionist.Id
      }
    },
    show(val) {
      if (!val) this.UserId = ''
    }
  },
  methods: {
    submit() {
      if (!this.UserId) return
      this.loading = true
      let data = {
        UserId: this.UserId,
        TermId: this.item.Id,
      }
      this.$http.post(this.$api.nutritionist.assign, data).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('done')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>